export default __webpack_public_path__ + "static/media/highpoint_logo.7e45cb13.png";